const DEMAND_ANALYSIS_DECISION_KEY = '@atlas:v1:demand-analysis-decision'

export type DecisionType = 'edition' | 'substitution'

export function saveDemandAnalysisDecisionAnswer(
  type: DecisionType,
  rememberAnswer: boolean,
): void {
  const key = `${DEMAND_ANALYSIS_DECISION_KEY}:${type}`
  localStorage.setItem(key, JSON.stringify(rememberAnswer))
}

export function getDemandAnalysisDecisionAnswer(type: DecisionType): boolean {
  const key = `${DEMAND_ANALYSIS_DECISION_KEY}:${type}`
  const storedAnswer = localStorage.getItem(key)

  if (storedAnswer) {
    return JSON.parse(storedAnswer)
  }

  return false
}
